module.exports = __webpack_public_path__ + "media/images/products/products/j1-e0ca6ec379a282bc88e56cbd90105177.jpg";